import { Routing } from "./shared/routing.js";
import { Localize } from "./shared/localize.js";

class HelperTire {
  constructur() {

  }

  ToUrl = (t) => {
    var ret = "";

    var a = [];
    var qs = [];

    switch (t.season) {
      case "EST":
        a.push(Routing.R("gomme-estive"));
        break;
      case "INV":
        a.push(Routing.R("gomme-invernali"));
        break;
      case "ALL":
        a.push(Routing.R("gomme-4-stagioni"));
        break;
      default:
        a.push(Routing.R("gomme"));
        break;
    }

    if (t.slug) {
      //empty
    }else if (t.brand) {
      a.push(t.brand);
    }

    if (t.width && t.ratio && t.diameter) {
      if (t.speed && t.load) {
        a.push(t.width + '-' + t.ratio + '-' + t.diameter + '-' + t.speed + '-' + t.load);
      } else if (t.speed) {
        a.push(t.width + '-' + t.ratio + '-' + t.diameter + '-' + t.speed);
      } else {
        a.push(t.width + '-' + t.ratio + '-' + t.diameter);
      }
    }

    if (t.isrunflat) {
      qs.push("isrunflat=1");
    }
    if (t.extraload) {
      qs.push("extraload=1");
    }
    if (t.fastdelivery) {
      qs.push("fastdelivery=1");
    }
    else if (t.fastdelivery != null) {
      qs.push("fastdelivery=0");
    }
    if (t.ktype) {
      qs.push("carid=" + t.ktype);
    }
    if (t.year) {
      qs.push("year=" + t.year);
    }

    ret = "/" + a.join('/') + (qs.length ? "?" + qs.join('&') : "");

    return ret.toLowerCase();
  }
}

export { HelperTire };